import {Stack, SxProps, Theme, Typography} from '@mui/material';
import {useTranslation} from 'react-i18next';
import {translations} from '../../../i18n/translations';
import {FiFilter} from 'react-icons/fi';

interface TaskFilterHeaderProps {
  title?: string;
  subtitleDay?: string;
  onFilterClick?: () => void;
}

export const TaskFilterHeader = ({title, subtitleDay, onFilterClick}: TaskFilterHeaderProps) => {
  const {t} = useTranslation();

  const headerWrapperSx: SxProps<Theme> = {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    height: '44px',
    padding: '0px 0.5px 0px 4.5px',
  };

  const textSx: SxProps<Theme> = {
    color: 'var(--dcm-gray)',
    fontFamily: 'Roboto',
    fontSize: '18px',
    fontStyle: 'normal',
    fontWeight: 500,
    lineHeight: '24px',
    letterSpacing: '0.225px',
    display: 'flex',
    alignItems: 'center',
  };

  const subtitleSx: SxProps<Theme> = {
    color: 'var(--dcm-gray-input)',
    fontFamily: 'Roboto',
    fontSize: '12px',
    fontStyle: 'normal',
    fontWeight: 500,
    lineHeight: '20px',
    marginLeft: '5px',
  };

  return (
    <Stack sx={headerWrapperSx}>
      <Typography sx={textSx}>
        {title || t(translations.daily_care_log.task_table.tasks)}
        {subtitleDay && (
          <Typography component="span" sx={subtitleSx}>
            - {subtitleDay}
          </Typography>
        )}
      </Typography>
      <Stack flexDirection="row" gap={3} alignItems="center" onClick={onFilterClick}>
        <Typography htmlFor="filter-label" component="label" sx={textSx}>
          {t(translations.daily_care_log.task_table.drawer.filters.title)}
        </Typography>
        <FiFilter id="filter-label" size={19} color="var(--dcm-gray)" />
      </Stack>
    </Stack>
  );
};
